module.exports = __webpack_public_path__ + "static/media/block.f7465604.svg";